module.exports = __webpack_public_path__ + "img/32M030.92d1adc0.png";